import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAccount from "../../../../core/api/api.account";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useLocation } from "react-router-dom";
import { NewSupplierAccountModal } from "./NewSupplierAccountModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import GlobalFormControl from "../../_Components/GlobalFormControl";

const Account = () => {
  const [listData, setListData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [showModalAccount, setShowModalAccount] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const location = useLocation();
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAccount.getAllAccount({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, [refresh]);
  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };
  const onSubmit = async (data) => {
    const apiData = await ApiAccount.getAllAccount({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
  };

    return (
    <div>
      {!_.isEmpty(location.state) && location.state?.newAgentAccount ? (
        <NewSupplierAccountModal callback={callBackJustForRunUseEffect} />
      ) : (
        ""
      )}
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              لیست حساب ها
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              {" "}
              لیست حساب های بانکی شما
            </span>
          </h3>
          <div className="card-toolbar">
            <Button
              variant="primary"
              onClick={() => {
                setSelectedAccountId(0);
                setShowModalAccount(true);
              }}
            >
              <AddCircle className="mr-1" />
              درج حساب جدید
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setShowModalAccount={setShowModalAccount}
                  setSelectedAccountId={setSelectedAccountId}
                />
              </Col>
            </form>
          </FormProvider>
          {showModalAccount && (
            <NewSupplierAccountModal
              showModalAccount={showModalAccount}
              setShowModalAccount={setShowModalAccount}
              selectedAccountId={selectedAccountId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Account;
